export default class ArrayUtil {

    get(list, objectId, idProperty) {
        for (let i = 0; i < list.length; i++) {

            // id can be stored in index to slightly obfuscate
            if (list[i].id === objectId || list[i].index === objectId) {
                return list[i]
            }

            if(idProperty && list[i][idProperty] === objectId) {
                return list[i]
            }
        }
    }

    update(list, object) {
        for (let i = 0; i < list.length; i++) {

            if (list[i].id === object.id) {
                list[i] = object
                break
            }
        }
    }

    remove(list, id) {
        for (let i = 0; i < list.length; i++) {

            if (list[i].id === id || list[i] === id) {
                list.splice(i, 1)
                break
            }
        }
    }

    getItemIndex(list, item) {
        for (let i = 0; i < list.length; i++) {

            if (list[i] === item) {
                return i
            }
        }

        return -1
    }

    swapElements (list, index1, index2) {
        const temp = list[index1]
        list[index1] = list[index2]
        list[index2] = temp
    };

    filter(list, stringFragment) {
        return list.filter((listItem) => {
            return listItem.indexOf(stringFragment) < 0
        })
    }

    filterAll(list, list2) {
        return list.filter((listItem) => {

            for (let i = 0; i < list2.length; i++) {
                if(listItem.indexOf(list2[i]) === 0) {
                    return false
                }
            }

            return true
        })
    }

    random(list) {
        return list[Math.floor(Math.random()*list.length)]
    }

    listToGrid(list, itemCountInRow) {
        let gridData = []
        let currentRow = []

        for (let i = 0; i < list.length; i++) {
            if (i % itemCountInRow === 0) {
                currentRow = []
                gridData.push(currentRow)
            }

            currentRow.push(list[i])
        }

        return gridData
    }
}